// extracted by mini-css-extract-plugin
module.exports = {"categorySlider":"category-slider_categorySlider__L4ZIz"};